<template>
	<div class="dashhead">
		<div class="dashhead-titles">
			<h6 class="dashhead-subtitle">{{subtitle}}</h6>
			<h2 class="dashhead-title">{{title}}</h2>
		</div>
		<div class="dashhead-toolbar text-right">
    		<p><a href="/#/user">{{username}}</a><span class="icon ml-1" :class="getUserIcon" ></span></p>			 
			<p>{{sitename}}</p>			 
  		</div>
	</div>
</template>

<script>
import store from '../state'

export default {
	name: 'DashHead',
	props: ['title','subtitle'],
	computed: {
		getUserIcon() {
			const impersonating = (store.state.originalJwt != null);
			return (impersonating) ? "icon-mask" : "icon-users";
		},
		username() {
				return `${store.state.user.firstName} ${store.state.user.lastName}`;
		},
		sitename() {
			return store.state.user.siteName;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/DashHead.vue